import React from 'react';
import PropTypes from 'prop-types';

const sizes = {
  tiny: ['12px', '12px'],
  small: ['16px', '16px'],
  middle: ['24px', '24px'],
  large: ['32px', '32px'],
  huge: ['64px', '64px'],
};

const CrossIcon = (props) => {
  const size = typeof props.size === 'string' ? sizes[props.size] : props.size;
  const [width, height] = size;

  const svgProps = {
    width,
    height,
    style: Object.assign(
      props.shouldPadding ? { padding: '4px' } : {},
      props.style
    ),
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...svgProps}
    >
      <path
        fill="currentColor"
        d="M12 10.586L6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 001.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 10-1.414-1.414L12 10.586z"
      />
    </svg>
  );
};

CrossIcon.defaultProps = {
  size: 'middle',
  shouldPadding: false,
  style: {},
};

CrossIcon.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['small', 'middle', 'large', 'huge']),
    PropTypes.array,
  ]),
  shouldPadding: PropTypes.bool,
  style: PropTypes.object,
};

export default CrossIcon;
